/*
 *
 * OperationSummary
 *
 * @version 1.0.0
 * @author Stefano Servodidio
 * @since 01-Jul-2024
 */

import OperationSummary from './OperationSummaryContainer'

export default OperationSummary
